/** @module */
import { AbstractConsumer } from './abstract-consumer';


/**
 * Extend, instantiate and configure to request API endpoints.
 * @see {@link abstract-consumer.md} for inherited API.
 * @abstract
 */
export class Consumer extends AbstractConsumer {}
